import { useDroppable } from '@dnd-kit/core'
import cn from 'classnames'
import * as React from 'react'
import { EmptyPositionCard } from '../EmptyPositionCard'
import type { EmptyPositionCardProps } from '../EmptyPositionCard'
import styles from './DisciplineSection.module.scss'

type DroppableEmptyBlockSlotProps = EmptyPositionCardProps & {
  disciplineId: number
}

/**
 * Wraps EmptyPositionCard with a droppable zone so a position card can be
 * dragged onto an empty block.  The droppable ID encodes the target block:
 *   block-{disciplineId}-{seniorityLevel}
 */
export const DroppableEmptyBlockSlot: React.FC<
  DroppableEmptyBlockSlotProps
> = ({ disciplineId, seniorityLevel, className, ...rest }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: `block-${disciplineId}-${seniorityLevel}`,
  })

  return (
    <div
      ref={setNodeRef}
      className={cn({ [styles.dropTarget]: isOver }, className)}
    >
      <EmptyPositionCard seniorityLevel={seniorityLevel} {...rest} />
    </div>
  )
}
